@if (pixelUrl) {
  <img height="1" width="1" style="display: none" alt="" [src]="pixelUrl" />
}
